module.exports = __webpack_public_path__ + "static/img/stud-mounted-sign.661cf53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/general-frames/stud-mounted-sign.jpg
// module id = 724
// module chunks = 0